import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'telefoneFormat',
  standalone: true
})
export class TelefoneFormatPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value) return '';

    let valorStr = value.toString().replace(/\D/g, '');

    if (valorStr.length === 11) {
      return valorStr.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
    } else if (valorStr.length === 10) {
      return valorStr.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
    }

    return value;
  }
}
